import { parseUrl } from './parse-url';

export type TextSegment = {
  kind: 'text';
  value: string;
};

export type UrlSegment = {
  kind: 'url';
  value: string;
  href: string;
};

export type TextWithUrlsSegment = TextSegment | UrlSegment;

const urlRegex =
  // eslint-disable-next-line max-len -- regex needs this length
  /\b[a-z][a-z0-9+.-]*:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]|\bwww\.[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]|\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b|\b[A-Z0-9.-]+\.[A-Z]{2,}\b|\bmailto:[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]/gi;

export const splitTextWithUrls = (value: string): TextWithUrlsSegment[] => {
  if (!value) {
    return [];
  }

  const matches = [...value.matchAll(urlRegex)];

  if (!matches.length) {
    return [{ kind: 'text', value }];
  }

  const segments: TextWithUrlsSegment[] = [];
  let lastIndex = 0;

  matches.forEach((match) => {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      segments.push({
        kind: 'text',
        value: value.substring(lastIndex, matchIndex),
      });
    }

    const url = match[0];
    segments.push({
      kind: 'url',
      value: url,
      href: parseUrl(url),
    });

    lastIndex = matchIndex + url.length;
  });

  if (lastIndex < value.length) {
    segments.push({ kind: 'text', value: value.substring(lastIndex) });
  }

  return segments;
};
